export function temHistoricoModalidade(cliente,modalidade){
 const valor=cliente?.[modalidade==='permuta'?'tem_permuta':'tem_pre_pago'];
 return valor===true||valor===1||valor==='1';
}
